import script from "./TableHeaderInvoiceTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHeaderInvoiceTemplate.vue?vue&type=script&setup=true&lang=js"

import "./TableHeaderInvoiceTemplate.vue?vue&type=style&index=0&id=420dfd14&lang=css"

const __exports__ = script;

export default __exports__